import { render, staticRenderFns } from "./FormulaBase.vue?vue&type=template&id=961286c8"
import script from "./FormulaBase.vue?vue&type=script&lang=js"
export * from "./FormulaBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports